'use strict';

var jQuery = require('jquery');
var React = require('react');
var ReactDOM = require('react-dom');
var isNode = typeof document === 'undefined'

if (!isNode) {
    var History = require('./history.jsx');

    require('./global.scss');
}

var Constants = require('../constants');

import '../../../../common-js/framework/Sentry.jsx';
import { ParseAPI } from './frontend-parse-api.js';

// ------------------------------------------------------------------------------

var firstload = false;

function GAPageview(location, replaceWith) {
    if (!isNode) {
        // Don't send pageview event for initial page load as the regular GA tracking snippet will
        if (!firstload) {
            firstload = true;
        } else if (typeof ga !== 'undefined') {
            ga('send', 'pageview', location.location.pathname);
        }
    }
}

// ------------------------------------------------------------------------------

function SPLOG(msg) {
    console.log(msg);
    if (typeof Raven !== 'undefined') {
        Raven.captureMessage(msg);
    }
}

// ------------------------------------------------------------------------------

if (!isNode) {
    jQuery(document).ready(function() {
        window.addEventListener('dragover', function(e) {
            e = e || event;
            e.preventDefault();
        }, false);
        window.addEventListener('drop', function(e) {
            e = e || event;
            e.preventDefault();
        }, false);
    });
}

// ------------------------------------------------------------------------------

module.exports = {
    GAPageview: GAPageview,
    History:    History ? History.browserHistory : null,

    DeviceImage:     require('./device-image.jsx'),
    ResponsiveMixin: require('./responsive.jsx'),
    Fonts:           require('./fonts.js'),

    ParseAPI:          ParseAPI,

    rStore:            require('./rstore.js'),
};



// WEBPACK FOOTER //
// ./src/global/global.jsx